module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av541-3a496418c0363be4579ecff9de0ae189.jpg";